// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__EZHqP","vLegacy":"SelectSecondary_vLegacy__3l-Td","error":"SelectSecondary_error__1jysm","disabled":"SelectSecondary_disabled__2w_WX"};